
import NavbarForDesktop from "../Desktop/navbarForDesktop";
import Signin_form from "./singin_form";





export default function LoginPage() {

    return (
        <>
            <Signin_form /> 
        </>
        
    )
}